module.exports = __webpack_public_path__ + "img/TelefonicaWeb-Thin.249429ee.svg";